module.exports = __webpack_public_path__ + "media/src/images/icons/link_new-a38da7c1ec85494b4c4b7f7e324da555.svg";